const nav = document.querySelector('.header-nav');
const toggle = nav.querySelector('.nav-toggle');

toggle.addEventListener('click', (evt) => {
  evt.stopPropagation();

  if (nav.classList.contains('active')) {
    nav.classList.remove('active');
  } else {
    nav.classList.add('active');
  }
});
